import { InputLabel, Textarea } from '@ibsys/kit';
import { FC } from 'react';
import { FieldPath, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { cn } from '@/shared/lib';
import { RuleInfoButton } from './RuleInfoPopup';
import { AttributeFormValues } from './validation';

type Props = {
  /** Путь поля правила в форме: у простого атрибута и у поля структуры он разный */
  name: FieldPath<AttributeFormValues>;
  disabled?: boolean;
  rows?: number;
  className?: string;
  /** Классы области ввода — ограничение её высоты зависит от места, где поле показано */
  inputClassName?: string;
};

/**
 * Поле правила извлечения со значком справки по синтаксису.
 * Значок стоит в строке подписи: так он не перекрывает область ввода при любой ширине
 * карточки и не отнимает у неё ширину — поле заканчивается на одной линии с остальными
 * полями формы. Выравнивание значка по центру поля ставило бы его положение в
 * зависимость от высоты поля.
 */
export const RuleField: FC<Props> = ({ name, disabled, rows, className, inputClassName }) => {
  const { t } = useTranslation('attributes');
  const { control } = useFormContext<AttributeFormValues>();

  return (
    <div className={cn('grid grid-cols-[1fr_auto] items-end gap-x-2 gap-y-1', className)}>
      <InputLabel htmlFor={name}>{t('rule')}</InputLabel>
      <RuleInfoButton />
      <Textarea
        control={control}
        id={name}
        name={name}
        rows={rows}
        disabled={disabled}
        placeholder={t('rulePlaceholder')}
        classNames={{ input: inputClassName }}
        className="col-span-2 min-w-0"
      />
    </div>
  );
};
